module.exports = __webpack_public_path__ + "img/edit-selected.01a7c518.svg";